// @flow

import type { Action } from './store.type';

export const VERIFY_DISCOUNT_CODE_REQUEST = 'VERIFY_DISCOUNT_CODE_REQUEST';
type VERIFY_DISCOUNT_CODE_REQUEST_TYPE = 'VERIFY_DISCOUNT_CODE_REQUEST';

export const VERIFY_DISCOUNT_CODE_SUCCESS = 'VERIFY_DISCOUNT_CODE_SUCCESS';
type VERIFY_DISCOUNT_CODE_SUCCESS_TYPE = 'VERIFY_DISCOUNT_CODE_SUCCESS';

export const VERIFY_DISCOUNT_CODE_FAILURE = 'VERIFY_DISCOUNT_CODE_FAILURE';
type VERIFY_DISCOUNT_CODE_FAILURE_TYPE = 'VERIFY_DISCOUNT_CODE_FAILURE';

export const SUBSCRIBE_PLAN_REQUEST = 'SUBSCRIBE_PLAN_REQUEST';
type SUBSCRIBE_PLAN_REQUEST_TYPE = 'SUBSCRIBE_PLAN_REQUEST';

export const SUBSCRIBE_PLAN_SUCCESS = 'SUBSCRIBE_PLAN_SUCCESS';
type SUBSCRIBE_PLAN_SUCCESS_TYPE = 'SUBSCRIBE_PLAN_SUCCESS';

export const SUBSCRIBE_PLAN_FAILURE = 'SUBSCRIBE_PLAN_FAILURE';
type SUBSCRIBE_PLAN_FAILURE_TYPE = 'SUBSCRIBE_PLAN_FAILURE';

export const ACTIVATE_CHARGE_REQUEST = 'ACTIVATE_CHARGE_REQUEST';
type ACTIVATE_CHARGE_REQUEST_TYPE = 'ACTIVATE_CHARGE_REQUEST';

export const ACTIVATE_CHARGE_SUCCESS = 'ACTIVATE_CHARGE_SUCCESS';
type ACTIVATE_CHARGE_SUCCESS_TYPE = 'ACTIVATE_CHARGE_SUCCESS';

export const ACTIVATE_CHARGE_FAILURE = 'ACTIVATE_CHARGE_FAILURE';
type ACTIVATE_CHARGE_FAILURE_TYPE = 'ACTIVATE_CHARGE_FAILURE';

export const CLEAR_DISCOUNT_CODE = 'CLEAR_DISCOUNT_CODE';
type CLEAR_DISCOUNT_CODE_TYPE = 'CLEAR_DISCOUNT_CODE';

type SubscriptionSuccess = {
  data: Object
};

type SubscriptionFailure = {
  error: any
};

// Verify discount code
type VerifyDiscountCodeRequestAction = Action<VERIFY_DISCOUNT_CODE_REQUEST_TYPE, null>;

type VerifyDiscountCodeSuccessAction = Action<
  VERIFY_DISCOUNT_CODE_SUCCESS_TYPE,
  SubscriptionSuccess
>;

type VerifyDiscountCodeFailureAction = Action<
  VERIFY_DISCOUNT_CODE_FAILURE_TYPE,
  SubscriptionFailure
>;

// Subscribe plan
type SubscribePlanRequestAction = Action<SUBSCRIBE_PLAN_REQUEST_TYPE, null>;

type SubscribePlanSuccessAction = Action<SUBSCRIBE_PLAN_SUCCESS_TYPE, SubscriptionSuccess>;

type SubscribePlanFailureAction = Action<SUBSCRIBE_PLAN_FAILURE_TYPE, SubscriptionFailure>;

// Active charge
type ActivateChargeRequestAction = Action<ACTIVATE_CHARGE_REQUEST_TYPE, null>;

type ActivateChargeSuccessAction = Action<ACTIVATE_CHARGE_SUCCESS_TYPE, SubscriptionSuccess>;

type ActivateChargeFailureAction = Action<ACTIVATE_CHARGE_FAILURE_TYPE, SubscriptionFailure>;

type ClearDiscountCodeAction = Action<CLEAR_DISCOUNT_CODE_TYPE, null>;

export type SubscriptionAction =
  | VerifyDiscountCodeRequestAction
  | VerifyDiscountCodeSuccessAction
  | VerifyDiscountCodeFailureAction
  | SubscribePlanRequestAction
  | SubscribePlanSuccessAction
  | SubscribePlanFailureAction
  | ActivateChargeRequestAction
  | ActivateChargeSuccessAction
  | ActivateChargeFailureAction
  | ClearDiscountCodeAction;

export type SubsciptionState = {
  verifying: boolean,
  subscribing: boolean,
  activating: boolean,
  subscribeSuccess: boolean,
  success: boolean,
  error: any,
  percent: 0,
  confirmationUrl: string,
  migrateESCluster: boolean
};
